import { useUser } from "@hooks/user";
import { Intercom } from "@services";

export const useIntercom = () => {
  const { user } = useUser();

  Intercom.init({
    user_id: user?.id ?? "",
    name: `${user?.firstName} ${user?.lastName}`,
    email: user?.email ?? "",
  });
};
